export const CF_ALL_ACCESS_MONTHLY_PRICE_USD = 9
export const CF_ALL_ACCESS_MONTHLY_PRICE_OTHER = 8.99
export const CF_ALL_ACCESS_YEARLY_PRICE = 59.88
// oxlint-disable-next-line unicorn/no-zero-fractions
export const CF_ALL_ACCESS_YEARLY_PROMO_PRICE = 47.0
export const CF_ALL_ACCESS_YEARLY_MONTHLY_SPLIT_PRICE = 4.99
export const CF_ALL_ACCESS_YEARLY_PROMO_MONTHLY_SPLIT_PRICE = 3.99
export const CF_ALL_ACCESS_YEARLY_MONTHLY_FULL_PRICE = 29

export const CF_STUDIO_AI_YEARLY_PROMO_PRICE = 59.88
export const CF_STUDIO_AI_YEARLY_MONTHLY_SPLIT_PRICE = 5.99
export const CF_STUDIO_AI_YEARLY_PROMO_MONTHLY_SPLIT_PRICE = 4.99
export const CF_STUDIO_AI_YEARLY_MONTHLY_FULL_PRICE = 29

export const CF_TEAM_MONTHLY_PRICE = 49.99

// oxlint-disable-next-line unicorn/no-zero-fractions
export const CF_ALL_ACCESS_YEARLY_WORTH_VALUE = 348.0
export const CF_COINS_TOP_UP_25K_PRICE_USD = 3.99
export const CF_COINS_TOP_UP_100K_PRICE_USD = 9.99
export const CF_COINS_TOP_UP_250K_PRICE_USD = 19.99
export const CF_COINS_TOP_UP_1000K_PRICE_USD = 69.99

export const YEARLY_EXTENSION_PRICE = 3.99
export const YEARLY_FREE_TRIAL_TOTAL_PRICE = 0

// NL VAT Included - Start
export const VAT_INCLUDED_CF_ALL_ACCESS_MONTHLY_PRICE_NL = 10.88
export const VAT_INCLUDED_CF_ALL_ACCESS_YEARLY_PRICE_NL = 72.45
export const VAT_INCLUDED_CF_ALL_ACCESS_YEARLY_PROMO_PRICE_NL = 56.87
export const VAT_INCLUDED_CF_ALL_ACCESS_YEARLY_MONTHLY_SPLIT_PRICE_NL = 6.04
export const VAT_INCLUDED_CF_ALL_ACCESS_YEARLY_PROMO_MONTHLY_SPLIT_PRICE_NL = 4.74
export const VAT_INCLUDED_CF_ALL_ACCESS_YEARLY_MONTHLY_FULL_PRICE_NL = 35.09
export const VAT_INCLUDED_CF_COINS_TOP_UP_25K_PRICE_USD = 4.83
export const VAT_INCLUDED_CF_COINS_TOP_UP_100K_PRICE_USD = 12.09
export const VAT_INCLUDED_CF_COINS_TOP_UP_250K_PRICE_USD = 24.19
export const VAT_INCLUDED_CF_COINS_TOP_UP_1000K_PRICE_USD = 84.69

export const VAT_INCLUDED_CF_COIN_PACK_MONTHLY_400K_PRICE_NL = 36.29
export const VAT_INCLUDED_CF_COIN_PACK_MONTHLY_700K_PRICE_NL = 60.49

export const VAT_INCLUDED_CF_STUDIO_AI_YEARLY_PROMO_PRICE_NL = 72.45
export const VAT_INCLUDED_CF_STUDIO_AI_YEARLY_MONTHLY_SPLIT_PRICE_NL = 7.25
export const VAT_INCLUDED_CF_STUDIO_AI_YEARLY_PROMO_MONTHLY_SPLIT_PRICE_NL = 6.04
export const VAT_INCLUDED_CF_STUDIO_AI_YEARLY_MONTHLY_FULL_PRICE_NL = 35.09

// NL VAT Included - End

//Michaels Digital
export const MD_ALL_ACCESS_MONTHLY_PRICE = 9.99
export const MD_ALL_ACCESS_YEARLY_FULL_PRICE = 119.88
export const MD_ALL_ACCESS_YEARLY_PRICE = 83.88
export const MD_ALL_ACCESS_YEARLY_PROMO_PRICE = 69.99
export const MD_ALL_ACCESS_YEARLY_MONTHLY_SPLIT_PRICE = 6.99
export const MD_ALL_ACCESS_YEARLY_PROMO_MONTHLY_SPLIT_PRICE = 5.99
